import { QC_FINISHED } from 'redux/actionTypes/global';
import { loadCellSets } from '../cellSets';
var qcFinished = function qcFinished(experimentId) {
  return function (dispatch) {
    // If the pipeline finished we have a new clustering, so fetch it
    dispatch(loadCellSets(experimentId, {
      forceReload: true
    }));
    dispatch({
      type: QC_FINISHED
    });
  };
};
export default qcFinished;